import { Outlet, Navigate } from 'react-router-dom'
import { LandingNavbar } from '@/modules/landing/components/LandingNavbar'
import { LandingFooter } from '@/modules/landing/components/LandingFooter'
import { useScrollReveal } from '@/hooks/useScrollReveal'
import { useAuthStore } from '@/stores/auth.store'

export function LandingLayout() {
  useScrollReveal()
  const { isAuthenticated } = useAuthStore()

  if (isAuthenticated) return <Navigate to="/dashboard" replace />

  return (
    <div className="landing-page flex flex-col min-h-screen">
      <LandingNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  )
}
